<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.editNewsTitle" | translate }}
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container" cdkDropList (cdkDropListDropped)="drop($event)">
  <div *ngFor="let i of data" class="news-item" cdkDrag>
    <div class="icon-navigate" cdkDragHandle>
      <img src="assets\img\Arrange_Order.svg" />
    </div>

    <textarea
      [(ngModel)]="i.text"
      [rows]="1"
      [cols]="50"
      pInputTextarea
      autoResize="autoResize"
      placeholder="{{
        'translate.dashboard.addNewsItemPlaceholder' | translate
      }}"
    ></textarea>

    <div class="icon-navigate">
      <img src="assets\img\Delete.svg" (click)="deleteItem(i)" />
    </div>
  </div>
</div>

<div class="t-panel-cell t-buttonSet l-align-end">
  <button [disabled]="saving" (click)="add()" class="t-button-outline">
    {{ "translate.dashboard.addNewsItem" | translate }}
  </button>

  &nbsp; &nbsp;

  <spinner *ngIf="saving"></spinner>
  <button
    [disabled]="saving"
    (click)="save()"
    class="t-button-outline inverted"
  >
    {{ "translate.general.save" | translate }}
  </button>
</div>
